import React, { useEffect } from "react";
import SmallVendorHero from "./SmallVendorHero";
import FeaturedVendorsSection from "./FeaturedVendorsSection";
import NominateVendorSection from "./NominateVendorSection";
import VendorCategoriesSection from "./VendorCategoriesSection";
import HowItWorksSection from "./HowItWorksSection";
import VendorImpactSection from "./VendorImpactSection";
import NgoPartnersSection from "./NgoPartnersSection";
import FaqSection from "./FaqSection";
import { useDispatch } from "react-redux";
import { fetchCmsHomeAction } from "../../store/slices/cmsSlice";

const SmallVendors = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCmsHomeAction());
  }, [dispatch]);

  return (
    <>
      <SmallVendorHero />
      <FeaturedVendorsSection />
      <NominateVendorSection />
      <VendorCategoriesSection />
      <HowItWorksSection />
      <VendorImpactSection />
      <NgoPartnersSection />
      <FaqSection />
    </>
  );
};

export default SmallVendors;
